module.exports = __webpack_public_path__ + "static/media/icon_benefit_shirt.9a957ed4.svg";